import { styled, Theme, Alert } from '@mui/material';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      maxWidth: '590px',
      width: '100%',
      borderRadius: '12px',
    },
  },
  dialogTitlesWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1.5rem',
  },
  alertWrap: {
    padding: '1.5rem 1rem 0',
  },
  dragAndDropZoneWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    padding: '1.5rem 1rem',
  },
  supportedFilesText: (theme: Theme) => ({
    pointerEvents: 'none',
    color: theme.palette.grey['600'],
  }),
  uploadedFilesWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  uploadedFileTitle: (theme: Theme) => ({
    fontSize: '0.813rem',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
  }),
};

export const StyledAlert = styled(Alert)(({ theme }) => ({
  alignItems: 'start',
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px !important',
  border: `1px solid ${theme.palette.error.main}`,
  color: theme.palette.error.main,
}));

export const StyledDragAndDropZone = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '1.5rem',
  border: `1px dashed ${theme.palette.grey['300']}`,
  borderRadius: '4px',
  cursor: 'pointer',
}));
